<template>
    <md-field
      :class="fieldClass"
      :inline="inline"
      :clearable="clearable"
      :togglePassword="togglePassword"
    >
      <label v-if="label" :for="id">{{ label }}</label>
      <md-input
        :id="id"
        :type="type"
        :ref="name"
        :name="name"
        :value="value"
        :counter="counter"
        :required="required"
        :disabled="disabled"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :readonly="readonly"
        :class="'text-align-' + align"
        :step="step"
        :autocomplete="autocomplete ? 'on' : 'off'"
        @input="onInput"
        @blur="onBlur2"
        @focus="onFocus2"
        v-on:keyup.enter="onEnterKeypress"
      />
      <span class="md-error" v-if="errorMessage">{{ errorMessage }}</span>
      <div class="absoulte" v-if="focus">
        <p v-for="el in formattedList" :key="`${el}-list`" @click="setValue(el)">{{ el }}</p>
        <p v-if="!formattedList.length">{{ this.value  }} ({{ secLabel }})</p>
      </div>
    </md-field>
  </template>
  
  <script>
   /* eslint-disable */
    import FieldMixin from './field.mixin'
    import { i18n } from '@js/i18n'

    export default {
      name: 'input-field2',
      mixins: [FieldMixin],
      props: {
        type: { type: String, default: 'text' },
        secLabel: {type: String, default: null },
        maxlength: { type: [Number, null], default: null },
        counter: { type: [Number, null], default: null },
        readonly: { type: Boolean, default: false },
        align: { type: String, default: 'left' },
        step: { type: Number, default: 0.000001 },
        disabled: { type: Boolean, default: false },
        id: { type: String, default: '' },
        autocomplete: { type: Boolean, default: true },
        autofocus: {type: Boolean, default: false},
        inline: {type: Boolean, default: false},
        list: {type: Array, default: []}
        // TODO: need handle number properties:
        // min: { type: Number, default: 0 },
      },
      data () {
        return {
          focus: false,
          i18n
        }
      },
      mounted () {
        if (this.autofocus) {
          setTimeout(() => this.$refs[this.name].$el.focus(), 100)
        }
      },
      computed: {
        isList () {
          return this.value && this.focus
        },
        formattedList () {
          return this.list.filter(el => el.includes(this.value))
        }
      },
      methods: {
        onFocus2() {
          this.$emit('focus')
          this.focus = true
        },
        onBlur2 () {
          this.$emit('blur')
          setTimeout(() => {
            this.focus = false
          }, 100)
        },
        setValue (el) {
          this.value = el
        }
      }
    }
  </script>
  
  <style scoped  lang="scss">
    @import '~scss/variables.scss';
  /deep/.md-field {
    position: relative;
  }
  .absoulte {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 108px;
    overflow: auto;
    z-index: 100;
    background-color: $default-white;
    border: 1px solid black;
    border-radius: 5px;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background:  #e1e1e1;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #757575;
      border-radius: 8px;
    }
    p {
      cursor: pointer;
      color: black;
      padding: 8px 10px;
      transition: all 0.2s ease-in-out;
      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.1);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/common/fields/InputField2.vue